export const DEAFULT_ERROR_MESSAGE = {
  message: 'An unexpected error occured, Please contact support@doselect.com',
  copyText: 'support@doselect.com',
  delay: true,
};

export const API_ERROR = {
  IDT: {
    500: {
      message:
        'Something went wrong, Please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    502: {
      message:
        'Something went wrong, Please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    503: {
      message:
        'Something went wrong, Please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    504: {
      message:
        'Something went wrong, Please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    network_error: {
      message: 'Please check your internet connection and refresh the page.',
      delay: true,
    },
  },
  VID: {
    500: {
      message:
        'Error uploading video, Please try again If issue still persists contact',
      copyText: 'support@doselect.com',
      delay: true,
    },
    502: {
      message:
        'Error uploading video, Please try again If issue still persists contact',
      copyText: 'support@doselect.com',
      delay: true,
    },
    503: {
      message:
        'Error uploading video, Please try again If issue still persists contact',
      copyText: 'support@doselect.com',
      delay: true,
    },
    504: {
      message:
        'Error uploading video, Please try again If issue still persists contact',
      copyText: 'support@doselect.com',
      delay: true,
    },
    network_error: {
      message:
        'Error uploading video. Please check your internet connection and try again.',
      copyText: null,
      delay: true,
    },
    default: {
      message: 'An unexpected error occured. Please contact',
      copyText: 'support@doselect.com',
      delay: true,
    },
  },
  ADO: {
    500: {
      message:
        'Error uploading audio, Please try again If issue still persists contact',
      copyText: 'support@doselect.com',
      delay: true,
    },
    502: {
      message:
        'Error uploading audio, Please try again If issue still persists contact',
      copyText: 'support@doselect.com',
      delay: true,
    },
    503: {
      message:
        'Error uploading audio, Please try again If issue still persists contact',
      copyText: 'support@doselect.com',
      delay: true,
    },
    504: {
      message:
        'Error uploading audio, Please try again If issue still persists contact',
      copyText: 'support@doselect.com',
      delay: true,
    },
    network_error: {
      message:
        'Error uploading audio. Please check your internet connection and try again.',
      copyText: null,
      delay: true,
    },
    default: {
      message: 'An unexpected error occured. Please contact',
      copyText: 'support@doselect.com',
      delay: true,
    },
  },
  VDS: {
    401: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    500: {
      message:
        'Something went wrong, Please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    502: {
      message:
        'Something went wrong, Please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    503: {
      message:
        'Something went wrong, Please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    504: {
      message:
        'Something went wrong, Please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    network_error: {
      message: 'Please check your internet connection and refresh the page.',
      delay: true,
    },
  },
  GTC: {
    401: {
      message:
        'Error in loading programming languages. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    500: {
      message:
        'Error in loading programming languages. Please refresh the page, if issue still persists contact support@doselect.com for assistance.',
      copyText: 'support@doselect.com',
      delay: true,
    },
    502: {
      message:
        'Error in loading programming languages. Please refresh the page, if issue still persists contact support@doselect.com for assistance.',
      copyText: 'support@doselect.com',
      delay: true,
    },
    503: {
      message:
        'Error in loading programming languages. Please refresh the page, if issue still persists contact support@doselect.com for assistance.',
      copyText: 'support@doselect.com',
      delay: true,
    },
    504: {
      message:
        'Error in loading programming languages. Please refresh the page, if issue still persists contact support@doselect.com for assistance.',
      copyText: 'support@doselect.com',
      delay: true,
    },
    network_error: {
      message: 'Please check your internet connection and refresh the page.',
      delay: true,
    },
  },
  GST: {
    401: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    500: {
      message: 'Server issue. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    502: {
      message:
        'Something went wrong, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    503: {
      message:
        'Something went wrong, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    504: {
      message:
        'Something went wrong, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    network_error: {
      message: 'Please check your internet connection and refresh the page.',
      delay: true,
    },
  },
  AED: {
    400: {
      message: 'Unable to submit form. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    401: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    403: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    404: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    500: {
      message:
        'Form submission failed, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    502: {
      message:
        'Form submission failed, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    503: {
      message:
        'Form submission failed, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    504: {
      message:
        'Form submission failed, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    network_error: {
      message: 'Please check your internet connection and resubmit the form.',
      delay: true,
    },
  },
  ONB: {
    400: {
      message: 'Unable to submit form. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    401: {
      message: 'Something went wrong. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    403: {
      message: 'Something went wrong. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    404: {
      message: 'Unable to submit form. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    500: {
      message:
        'Form submission failed, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    502: {
      message:
        'Form submission failed, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    503: {
      message:
        'Form submission failed, please try again, If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    504: {
      message:
        'Form submission failed, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    network_error: {
      message: 'Please check your internet connection and resubmit the form.',
      delay: true,
    },
  },
  GTD: {
    401: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    403: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    404: {
      message: 'Error in getting details, please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    500: {
      message:
        'Error in getting details, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    502: {
      message:
        'Error in getting details, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    503: {
      message:
        'Error in getting details, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    504: {
      message:
        'Error in getting details, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    network_error: {
      message:
        'Error in getting details. Please check your internet connection and refresh the page.',
      delay: true,
    },
  },
  GHD: {
    401: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    403: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    404: {
      message: 'An error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    500: {
      message:
        'Something went wrong, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    502: {
      message:
        'Something went wrong, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    503: {
      message:
        'Something went wrong, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    504: {
      message:
        'Something went wrong, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    network_error: {
      message: 'Please check your internet connection and refresh the page.',
      delay: true,
    },
  },
  INV: {
    401: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    403: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    404: {
      message: 'An error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    500: {
      message:
        'Something went wrong, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    502: {
      message:
        'Something went wrong, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    503: {
      message:
        'Something went wrong, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    504: {
      message:
        'Something went wrong, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    network_error: {
      message: 'Please check your internet connection and refresh the page.',
      delay: true,
    },
  },
  REC: {
    401: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    403: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    404: {
      message: 'An error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    500: {
      message:
        'Something went wrong, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    502: {
      message:
        'Something went wrong, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    503: {
      message:
        'Something went wrong, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    504: {
      message:
        'Something went wrong, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    network_error: {
      message: 'Please check your internet connection and refresh the page.',
      delay: true,
    },
  },
  TIN: {
    400: {
      message:
        'Could not initiate the session. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    401: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    403: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    500: {
      message:
        'Could not initiate the session, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    502: {
      message:
        'Could not initiate the session, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    503: {
      message:
        'Could not initiate the session, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    504: {
      message:
        'Could not initiate the session, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    network_error: {
      message:
        'Could not initiate the session. Please check your internet connection and refresh the page.',
      delay: true,
    },
  },
  PID: {
    400: {
      message: 'Something went wrong. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    401: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    403: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    404: {
      message: '',
      delay: true,
    },
    500: {
      message:
        'Something went wrong, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    502: {
      message:
        'Something went wrong, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    503: {
      message:
        'Something went wrong, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    504: {
      message:
        'Something went wrong, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    network_error: {
      message: 'Please check your internet connection and refresh the page.',
      delay: true,
    },
  },
  PST: {
    400: {
      message: 'Something went wrong. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    401: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    403: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    404: {
      message: 'Something went wrong. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    500: {
      message:
        'Something went wrong, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    502: {
      message:
        'Something went wrong, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    503: {
      message:
        'Something went wrong, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    504: {
      message:
        'Something went wrong, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    network_error: {
      message: 'Please check your internet connection and refresh the page.',
      delay: true,
    },
  },
  STT: {
    400: {
      message: 'Something went wrong. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    401: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    403: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    500: {
      message:
        '<%= productType %> could not be started, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    502: {
      message:
        '<%= productType %> could not be started, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    503: {
      message:
        '<%= productType %> could not be started, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    504: {
      message:
        '<%= productType %> could not be started, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    network_error: {
      message:
        '<%= productType %> could not be started. Please check your internet connection and try again.',
      delay: true,
    },
  },
  SS1: {
    401: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    403: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    404: {
      message: '',
      delay: true,
    },
    500: {
      message:
        'Something went wrong, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    502: {
      message:
        'Something went wrong, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    503: {
      message:
        'Something went wrong, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    504: {
      message:
        'Something went wrong, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    network_error: {
      message: 'Please check your internet connection and refresh the page.',
      delay: true,
    },
  },
  SS2: {
    401: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    403: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    404: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    500: {
      message:
        'Something went wrong, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    502: {
      message:
        'Something went wrong, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    503: {
      message:
        'Something went wrong, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    504: {
      message:
        'Something went wrong, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    network_error: {
      message: 'Please check your internet connection and refresh the page.',
      delay: true,
    },
  },
  GSP: {
    401: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    403: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    404: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    500: {
      message:
        'Something went wrong, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    502: {
      message:
        'Something went wrong, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    503: {
      message:
        'Something went wrong, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    504: {
      message:
        'Something went wrong, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    network_error: {
      message: 'Please check your internet connection and refresh the page.',
      delay: true,
    },
  },
  GBP: {
    400: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    401: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    403: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    404: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    500: {
      message:
        'Error loading question, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    502: {
      message:
        'Error loading question, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    503: {
      message:
        'Error loading question, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    504: {
      message:
        'Error loading question, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    network_error: {
      message:
        'Error loading question. Please check your internet connection and refresh the page.',
      delay: true,
    },
  },
  GUS: {
    401: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    403: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    404: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    500: {
      message:
        'Error loading saved solution, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    502: {
      message:
        'Error loading saved solution, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    503: {
      message:
        'Error loading saved solution, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    504: {
      message:
        'Error loading saved solution, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    network_error: {
      message:
        'Error loading saved solution. Please check your internet connection and refresh the page.',
      delay: true,
    },
  },
  // user revision history
  URH: {
    401: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    403: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    404: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    500: {
      message:
        'Error loading saved solution, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    502: {
      message:
        'Error loading saved solution, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    503: {
      message:
        'Error loading saved solution, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    504: {
      message:
        'Error loading saved solution, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    network_error: {
      message:
        'Error loading saved solution. Please check your internet connection and refresh the page.',
      delay: true,
    },
  },
  FUP: {
    400: {
      message: 'Error in uploading file, Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    401: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    403: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    500: {
      message:
        'Error in uploading file, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    502: {
      message:
        'Error in uploading file, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    503: {
      message:
        'Error in uploading file, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    504: {
      message:
        'Error in uploading file, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    network_error: {
      message:
        'Error in uploading file. Please check your internet connection and try again.',
      delay: true,
    },
  },
  GSS: {
    401: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    403: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    404: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    500: {
      message:
        'Error loading solution, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    502: {
      message:
        'Error loading solution, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    503: {
      message:
        'Error loading solution, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    504: {
      message:
        'Error loading solution, please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    network_error: {
      message:
        'Error loading solution. Please check your internet connection and try again.',
      delay: true,
    },
  },
  UPS: {
    400: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    401: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    403: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    404: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    500: {
      message:
        'Error saving solution, Please try again If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    502: {
      message:
        'Error saving solution, Please try again If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    503: {
      message:
        'Error saving solution, Please try again If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    504: {
      message:
        'Error saving solution, Please try again If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    network_error: {
      message: 'There is an issue. Please reach out to support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
  },
  DPS: {
    401: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    403: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    500: {
      message:
        'Unable to clear the solution, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    502: {
      message:
        'Unable to clear the solution, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    503: {
      message:
        'Unable to clear the solution, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    504: {
      message:
        'Unable to clear the solution, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    network_error: {
      message:
        'Unable to clear solution. Please check your internet connection and try again.',
      delay: true,
    },
  },
  SMT: {
    400: {
      message: 'Unable to submit, please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    401: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    403: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    404: {
      message: 'Unable to submit, please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    500: {
      message:
        'Unable to submit, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    502: {
      message:
        'Unable to submit, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    503: {
      message:
        'Unable to submit, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    504: {
      message:
        'Unable to submit, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    network_error: {
      message:
        'Unable to submit. Please check your internet connection and try again.',
      delay: true,
    },
  },
  SMS: {
    400: {
      message:
        'Unable to submit the section, please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    401: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    403: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    500: {
      message:
        'Unable to submit the section, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    502: {
      message:
        'Unable to submit the section, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    503: {
      message:
        'Unable to submit the section, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    504: {
      message:
        'Unable to submit the section, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    network_error: {
      message:
        'Unable to submit the section. Please check your internet connection and try again.',
      delay: true,
    },
  },
  RTT: {
    400: {
      message:
        'Unable to retake assignment, Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    401: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    403: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    404: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    500: {
      message:
        'Unable to retake assignment, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    502: {
      message:
        'Unable to retake assignment, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    503: {
      message:
        'Unable to retake assignment, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    504: {
      message:
        'Unable to retake assignment, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    network_error: {
      message:
        'Unable to retake assignment, please check your internet connection and try again.',
      delay: true,
    },
  },
  RST: {
    400: {
      message:
        '<%= productType %> could not be started. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    401: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    403: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    404: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    500: {
      message:
        '<%= productType %> could not be started, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    502: {
      message:
        '<%= productType %> could not be started, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    503: {
      message:
        '<%= productType %> could not be started, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    504: {
      message:
        '<%= productType %> could not be started, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    network_error: {
      message:
        '<%= productType %> could not be started, please check your internet connection and try again.',
      delay: true,
    },
  },
  SFB: {
    400: {
      message: 'Could not submit feedback, Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    401: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    403: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    500: {
      message:
        'Could not submit feedback, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    502: {
      message:
        'Could not submit feedback, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    503: {
      message:
        'Could not submit feedback, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    504: {
      message:
        'Could not submit feedback, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    network_error: {
      message:
        'Could not submit feedback, please check your internet connection and try again.',
      delay: true,
    },
  },
  RAS: {
    400: {
      message: 'Could not report issue, Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    401: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    403: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    500: {
      message:
        'Could not report issue, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    502: {
      message:
        'Could not report issue, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    503: {
      message:
        'Could not report issue, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    504: {
      message:
        'Could not report issue, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    network_error: {
      message:
        'Could not report issue, please check your internet connection and try again.',
      delay: true,
    },
  },
  TSS: {
    401: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    403: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    404: {
      message: 'Error loading report, Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    500: {
      message:
        'Error loading report, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    502: {
      message:
        'Error loading report, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    503: {
      message:
        'Error loading report, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    504: {
      message:
        'Error loading report, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    network_error: {
      message:
        'Error loading report, please check your internet connection and try again.',
      delay: true,
    },
  },
  GCS: {
    400: {
      message:
        'Error loading language stub, Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    401: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    403: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    500: {
      message:
        'Error loading language stub, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    502: {
      message:
        'Error loading language stub, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    503: {
      message:
        'Error loading language stub, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    504: {
      message:
        'Error loading language stub, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    network_error: {
      message:
        'Error loading language stub, please check your internet connection and try again.',
      delay: true,
    },
  },
  RCD: {
    400: {
      message:
        'Unable to run code with custom input, Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    401: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    403: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    500: {
      message:
        'Unable to run code with custom input, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    502: {
      message:
        'Unable to run code with custom input, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    503: {
      message:
        'Unable to run code with custom input, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    504: {
      message:
        'Unable to run code with custom input, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    network_error: {
      message:
        'Unable to run code with custom input, please check your internet connection and try again.',
      delay: true,
    },
  },
  SCD: {
    400: {
      message: 'Unable to run code, Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    401: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    403: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    404: {
      message: 'Unable to run code, Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    500: {
      message:
        'Unable to run code, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    502: {
      message:
        'Unable to run code, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    503: {
      message:
        'Unable to run code, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    504: {
      message:
        'Unable to run code, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    network_error: {
      message:
        'Unable to run code, please check your internet connection and try again.',
      delay: true,
    },
  },
  WFS: {
    400: {
      message:
        'Could not initiate the session, Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    401: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    403: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    404: {
      message:
        'Could not initiate the session, Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    500: {
      message:
        'Could not initiate the session, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    502: {
      message:
        'Could not initiate the session, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    503: {
      message:
        'Could not initiate the session, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    504: {
      message:
        'Could not initiate the session, please try again. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    network_error: {
      message:
        'Could not initiate the session, please check your internet connection and try again.',
      delay: true,
    },
  },
  GFB: {
    401: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    403: {
      message:
        'An unexpected error occured. Please contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    500: {
      message: '',
      delay: true,
    },
    502: {
      message: '',
      delay: true,
    },
    503: {
      message: '',
      delay: true,
    },
    504: {
      message: '',
      delay: true,
    },
    network_error: {
      message: '',
      delay: true,
    },
  },
  GAS: {
    401: {
      message: 'Something went wrong, Please refresh the page.',
      delay: true,
    },
    403: {
      message: 'Something went wrong, Please refresh the page.',
      delay: true,
    },
    404: {
      message: 'Something went wrong, Please refresh the page.',
      delay: true,
    },
    500: {
      message: 'Something went wrong, Please refresh the page.',
      delay: true,
    },
    502: {
      message: 'Something went wrong, Please refresh the page.',
      delay: true,
    },
    503: {
      message: 'Something went wrong, Please refresh the page.',
      delay: true,
    },
    504: {
      message: 'Something went wrong, Please refresh the page.',
      delay: true,
    },
    network_error: {
      message: 'Please check your internet connection and refresh the page.',
      delay: true,
    },
  },
  RTQ: {
    400: {
      message: 'Unable to compile your query.',
      delay: true,
    },
    401: {
      message: 'An unexpected error occured.',
      delay: true,
    },
    403: {
      message: 'An unexpected error occured.',
      delay: true,
    },
    500: {
      message: 'Unable to compile your query, please try again.',
      delay: true,
    },
    502: {
      message: 'Unable to compile your query, please try again.',
      delay: true,
    },
    503: {
      message: 'Unable to compile your query, please try again',
      delay: true,
    },
    504: {
      message: 'Unable to compile your query, please try again.',
      delay: true,
    },
    network_error: {
      message:
        'Unable to compile your query, please check your internet connection and try again.',
      delay: true,
    },
  },
  INF: {
    500: {
      message:
        'Something went wrong, Please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    502: {
      message:
        'Something went wrong, Please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    503: {
      message:
        'Something went wrong, Please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    504: {
      message:
        'Something went wrong, Please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    network_error: {
      message: 'Please check your internet connection and refresh the page.',
      delay: true,
    },
  },
  INS: {
    500: {
      message:
        'Something went wrong, Please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    502: {
      message:
        'Something went wrong, Please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    503: {
      message:
        'Something went wrong, Please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    504: {
      message:
        'Something went wrong, Please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    network_error: {
      message: 'Please check your internet connection and refresh the page.',
      delay: true,
    },
  },
  ISV: {
    500: {
      message:
        'Something went wrong, Please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    502: {
      message:
        'Something went wrong, Please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    503: {
      message:
        'Something went wrong, Please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    504: {
      message:
        'Something went wrong, Please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    network_error: {
      message: 'Please check your internet connection and refresh the page.',
      delay: true,
    },
  },
  DWS: {
    DRI: {
      message: 'Reconnecting... Please wait for few seconds',
      delay: true,
    },
    DRE: {
      message:
        'Something went wrong, Please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
  },
  CVU: {
    500: {
      message:
        'Something went wrong, Please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    502: {
      message:
        'Something went wrong, Please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    503: {
      message:
        'Something went wrong, Please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    504: {
      message:
        'Something went wrong, Please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    network_error: {
      message: 'Please check your internet connection and refresh the page.',
      delay: true,
    },
  },
  CSU: {
    500: {
      message:
        'Something went wrong, Please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    502: {
      message:
        'Something went wrong, Please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    503: {
      message:
        'Something went wrong, Please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    504: {
      message:
        'Something went wrong, Please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    network_error: {
      message: 'Please check your internet connection and refresh the page.',
      delay: true,
    },
  },
  CSG: {
    500: {
      message:
        'Something went wrong, Please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    502: {
      message:
        'Something went wrong, Please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    503: {
      message:
        'Something went wrong, Please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    504: {
      message:
        'Something went wrong, Please refresh the page. If issue still persists contact support@doselect.com',
      copyText: 'support@doselect.com',
      delay: true,
    },
    network_error: {
      message: 'Please check your internet connection and refresh the page.',
      delay: true,
    },
  },
};
